export const ScanningVerification = {
  SCANNER: "Scanner",
  SIMULATION: "Simulation",
  INPUT: "Input"
} as const;
